/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { PropTypes } from "prop-types";
import { NavLink, generatePath } from "react-router-dom";
import parse from "html-react-parser";
import { Carousel, Container, Image } from "app/components";
import { useConfig } from "app/hooks";
// import { getPaginateData } from "../../../components/Pagination/utils";
import { Pagination } from 'react-pagination-bar';
import { TechnologyList, Title, TechnologyItem, PageContainerDiv, ContainerDiv } from "./styles";
import "./custom.css"
import {
  Events,
  FullSlider,
  SectionFive,
} from "app/modules/cinemaRent/components/Competition/styles";
import BoxSlider from "app/modules/cinemaRent/components/Competition/BoxSlider";

const propTypes = {
  technologies: PropTypes.oneOfType([PropTypes.array, PropTypes.any])
    .isRequired,
  technologyEvents: PropTypes.oneOfType([PropTypes.array, PropTypes.any])
    .isRequired,
  getTechnologies: PropTypes.func.isRequired,
  getTechnologyEvents: PropTypes.func.isRequired
};

const AllTechnologies = ({
  technologies: allTechnologies,
  technologyEvents,
  getTechnologies,
  getTechnologyEvents
}) => {
  const [t, i18n] = useTranslation();
  const { language } = i18n;
  const { routes } = useConfig();
  const [technologies, setTechnologies] = useState([]);
  // const [offset, setOffset] = useState(0);
  // const [limit, setLimit] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);
  const pagePostsLimit = 12;

  useEffect(() => {
    getTechnologies();
    getTechnologyEvents();
  }, []);

  useEffect(() => {
    if (allTechnologies?.length) {
      setTechnologies(() =>
        allTechnologies?.map(item => ({
          id: item?.id,
          name: item?.[(language === "en" ? "headline1EN" : "headline1")],
          description:
            item?.[
            (language === "en" ? "shortDescriptionEN" : "shortDescription")
            ],
          picture: item?.picture
        }))
      );
    }
  }, [allTechnologies]);

  // useEffect(() => {
  //   if (allTechnologies?.length) {
  //     const data = getPaginateData(technologies, offset, limit);

  //     setTechnologies(data.data);
  //   }
  // }, [offset, limit]);

  const languageContents = useMemo(
    () => ({
      title: language === "en" ? "title_en" : "title",
      shortDescription:
        language === "en" ? "shortDescription_en" : "shortDescription"
    }),
    [language]
  );

  const sliderPropsConfig = () => ({
    slidesToSlide: 1,
    centerMode: true,
    centerMargin: "20px",
    responsive: {
      desktop: {
        breakpoint: {
          max: 30000,
          min: 992
        },
        items: 3
      },
      tablet: {
        breakpoint: {
          max: 992,
          min: 480
        },
        items: 2
      },
      mobile: {
        breakpoint: {
          max: 480,
          min: 0
        },
        items: 1
      }
    }
  });

  const sliderRef = useRef(null);
  const sliderProps = useMemo(() => sliderPropsConfig(), []);

  return (
    <Container>
      <Title>{t("common.technologies")}</Title>
      <TechnologyList>
        <div className="technology-list__wrapper">
          {technologies?.length > 0 && (technologies?.slice((currentPage - 1) * pagePostsLimit, currentPage * pagePostsLimit)?.map(item => (
            <NavLink
              key={item?.id}
              className="technology-list__item"
              to={generatePath(routes.technologyDetails.pattern, {
                id: item.id
              })}
            >
              <TechnologyItem key={item.id}>
                <Image
                  className="technology-list__item-image"
                  src={item?.picture ?? ""}
                  alt={`${item.picture} image`}
                />
                <div className="technology-list__item-content">
                  <h2>{item.name}</h2>
                  <h3>{parse(item.description ?? "")}</h3>
                </div>
              </TechnologyItem>
            </NavLink>
          )))}
        </div>
      </TechnologyList>
      {/* {technologies?.length > limit && (
        <Pagination
          total={technologies.length}
          offset={offset}
          setOffset={setOffset}
          limit={limit}
          setLimit={setLimit}
        />
      )} */}
      {technologies?.length > pagePostsLimit && (
        <ContainerDiv>
          <PageContainerDiv>
            <Pagination
              currentPage={currentPage}
              itemsPerPage={pagePostsLimit}
              onPageChange={(pageNumber) => setCurrentPage(pageNumber)}
              totalItems={technologies?.length}
              pageNeighbours={2}
            />
          </PageContainerDiv>
        </ContainerDiv>
      )}
      <SectionFive>
        {technologyEvents?.length > 0 && (
          <FullSlider>
            <Events> {t("common.technology_event_title")}</Events>
            <Carousel
              {...sliderProps}
              refEl={sliderRef}
              className="cinema-rent__carousel giftCardSliderData"
            >
              {technologyEvents?.map((item, key) => (
                (item?.title || item?.title_en || item?.shortDescription_en || item?.shortDescription) && <BoxSlider key={key} item={item} />
              ))}
            </Carousel>
          </FullSlider>
        )}
      </SectionFive>
    </Container>
  );
};

AllTechnologies.propTypes = propTypes;

export default AllTechnologies;
